import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { isLakehouseContext } from '../../utils/restaurantContext';

const FEATURES = [
  {
    id: 1,
    img: '/images/feature-1.png',
    title: 'Seaside Seating',
    text:
      'Take a moment to step away from the chaos and find your inner peace. Let the calmness wash over you and soothe your soul. Remember, relaxation is just a breath away.'
  },
  {
    id: 2,
    img: '/images/feature-2.jpg',
    title: 'Signature Menu',
    text:
      'Our best, reserved for you. Explore the distinctive flavors and curated selections of our Signature Menu—a true taste of what we stand for.'
  },
  {
    id: 3,
    img: '/images/feature-3.png',
    title: 'Private Events',
    text:
      'The perfect canvas for your private event. From intimate dinners to exclusive parties, celebrate lifes milestones in a unique, beautifully preserved setting.'
  }
];

const RESTAURANT_TWO_FEATURES = [
  {
    id: 1,
    img: '/images/casagatchalianlakehouse - feature 1.jpg',
    title: 'Lakeside Seating',
    text:
      'Take a moment to step away from the chaos and find your inner peace. Let the calmness wash over you and soothe your soul. Remember, relaxation is just a breath away.'
  },
  {
    id: 2,
    img: '/images/casagatchalianlakehouse - feature 2.jpg',
    title: 'Signature Menu',
    text:
      'Our best, reserved for you. Explore the distinctive flavors and curated selections of our Signature Menu-a true taste of what we stand for.'
  },
  {
    id: 3,
    img: '/images/casagatchalianlakehouse - feature 3.jpg',
    title: 'Private Events',
    text:
      'The perfect canvas for your private event. From intimate dinners to exclusive parties, celebrate lifes milestones in a unique, beautifully preserved setting.'
  }
];

const FeaturesSection = () => {
  const { user } = useContext(AuthContext);
  const isRestaurantTwoUser = isLakehouseContext(user);
  const features = isRestaurantTwoUser ? RESTAURANT_TWO_FEATURES : FEATURES;

  return (
    <section
      id="features"
      className="relative bg-cover bg-center"
      style={{ backgroundImage: "url('/images/feature-bg.png')" }}
      aria-label="Features background"
    >
      <div className="absolute inset-0 bg-black/60"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10 sm:py-12 md:py-16 lg:py-20">
        <h3 className="font-bebas text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight text-white mb-6 sm:mb-8 tracking-wide">FEATURES</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 lg:gap-8">
          {features.map((f) => (
            <div key={f.id} className="bg-[#1a1a1a] rounded-2xl p-5 sm:p-5 md:p-6 text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-full h-48 sm:h-44 md:h-48 lg:h-52 mb-4 sm:mb-4 md:mb-6 overflow-hidden rounded-xl">
                <img
                  src={f.img}
                  alt={f.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  loading="lazy"
                />
              </div>
              <h4 className="text-white font-montserrat font-semibold mb-3 text-base sm:text-base md:text-lg">{f.title}</h4>
              <p className="text-white/90 text-sm sm:text-sm leading-relaxed">{f.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
